module.exports = __webpack_public_path__ + "assets/img/icon_prev_new.a88d7d40.svg";